import { render, staticRenderFns } from "./courses-page-toolbar.vue?vue&type=template&id=31b12566&scoped=true"
import script from "./courses-page-toolbar.vue?vue&type=script&lang=js"
export * from "./courses-page-toolbar.vue?vue&type=script&lang=js"
import style0 from "./courses-page-toolbar.vue?vue&type=style&index=0&id=31b12566&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b12566",
  null
  
)

export default component.exports